// REQUIRED IMPORTS
const $ = require('jquery');
import run from '../../utilities/run';
import render from "../../utilities/render";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";

const targetSelector = "#carrier-org-details-page";

run(targetSelector, (mainEl)=>{
  
    const deactivateOrgURL =  mainEl.data("deactivate-org-url");
    const orgId = mainEl.data("org-id");
    const organizationDetails = mainEl.data("organization-details");
    const activateOrg = mainEl.data("activate-org-msg");
    const deactivateOrg = mainEl.data("deactivate-org-msg") ;
    const activateOrgBtn = mainEl.data("activate-carrier-btn-txt");
    const deactivateOrgBtn = mainEl.data("deactivate-carrier-btn-txt") ;
    const editOrgUrl = mainEl.data("edit-url");

    let activateDiv = render('<div class="q-pad-all-xl">{%-activateMsg %}</div>', {
            activateMsg: mainEl.data("activate-org-text")
        }
    );
    let deactivateDiv = render('<div class="q-pad-all-xl">{%-deactivateMsg %}</div>', {
        deactivateMsg: mainEl.data("deactivate-org-text")
        }
    );

    const deactivateTeamMemberURL =  mainEl.data("deactivate-teammember-url");
    const activateTeamMember =  mainEl.data("activate-teammember-msg");
    const deactivateTeamMember =  mainEl.data("deactivate-teammember-msg") ;
    const deactivateBtnTxt =  mainEl.data("deactivate-teammember-btn-text") ;
    const activateBtnTxt =  mainEl.data("activate-teammember-btn-text") ;

    let activateTeamMemberDiv = render('<div class="q-pad-all-xl">{%-activateTeamMemberMsg %}</div>', {
            activateTeamMemberMsg:  mainEl.data("activate-teammember-text")
        }
    );

    let deactivateTeamMemberDiv = render('<div class="q-pad-all-xl">{%-deactivateTeamMemberMsg %}</div>', {
        deactivateTeamMemberMsg:  mainEl.data("deactivate-teammember-text")
        }
    );

    const pageRefreshUrl=mainEl.data("page-refresh-url");

    $('body').on('click', '#carrier-org-edit-url', function (e) {
        e.preventDefault();
        if(shallAllowClick(this)) { 
          editOrganizationCall(orgId);
        } 
      });

      $('body').on('click', '#edit-carrier-org-details', function (e) {
        e.preventDefault();
        if(shallAllowClick(this)) { 
          editOrganizationCall(orgId);
        } 
      });
    
      $('body').on('click', '#edit-carrier-org-contact', function (e) {
        e.preventDefault();
        if(shallAllowClick(this)) { 
          editOrganizationCall(orgId); 
        } 
      });

      $('body').on('click', '#edit-carrier-team-details', function (e) {
        e.preventDefault();
        if(shallAllowClick(this)) { 
          editOrganizationCall(orgId); 
        } 
      });
    
      function editOrganizationCall(orgId) {
        location.href = editOrgUrl + "&orgId=" + orgId;
      }
      function shallAllowClick(currentObj) {
        return !($(currentObj).hasClass("disabled"));
      }
    $('#deactivate-org-btn-carrier-details').on("click", function(e) {  
        let deactivateOrgModal = new SubmitModalFlow({
            confirmModalTitle: deactivateOrg,
            confirmModalBody: deactivateDiv,
            confirmModalBtnText: deactivateOrgBtn,
            modalDialogClass: "q-modal-dialog-500",
            onConfirmClick: function() {

                deactivateOrgModal.showLoadingModal();
                    deactivateOrg({url: deactivateOrgURL, success: deactivateSuccess, error: deactivateFailure});
                    function deactivateOrg({url, success, error}){
                        $.ajax({
                            data:  {
                                organizationId:orgId,
                                orgType:organizationDetails.orgType,
                                orgRetailerId:organizationDetails.orgRetailerId
                              },
                            url: url,
                            dataType:"JSON",
                            type: 'POST',
                            success: success,
                            error: error
                        });
                    }
                    function deactivateSuccess(){
                        deactivateOrgModal.showSuccessModal();
                        setTimeout(function() {
                            location.href=pageRefreshUrl;
                         }, 3000);
                    }
                    function deactivateFailure(){
                        deactivateOrgModal.showFailureModal();
                    }
                }
          });
          deactivateOrgModal.init();
          deactivateOrgModal.showConfirmModal();
    });
   
    
    $('#activate-org-btn-carrier-details').on("click", function(e) { 
        e.preventDefault();  
        let activateOrgModal = new SubmitModalFlow({
            confirmModalTitle: activateOrg,
            confirmModalBody: activateDiv,
            confirmModalBtnText: activateOrgBtn,
            modalDialogClass: "q-modal-dialog-500",
            onConfirmClick: function() {
               
                    activateOrgModal.showLoadingModal();
                    activateOrg({url: deactivateOrgURL, success: activateSuccess, error: activateFailure});
                    function activateOrg({url, success, error}){
                        $.ajax({
                            data:  {
                                organizationId:orgId,
                                orgType:organizationDetails.orgType,
                                orgRetailerId:organizationDetails.orgRetailerId
                              },
                            url: url,
                            dataType:"JSON",
                            type: 'POST',
                            success: success,
                            error: error
                        });
                    }
                    function activateSuccess(){
                        activateOrgModal.showSuccessModal();
                        setTimeout(function() {
                            location.href=pageRefreshUrl;
                         }, 3000);
                    }
                    function activateFailure(){
                     activateOrgModal.showFailureModal();   
                    }
                }
          });
          activateOrgModal.init();
          activateOrgModal.showConfirmModal();
    });

    $('.deactivate-org-team-member-btn').on("click", function(e) {  
        e.preventDefault();  
        let userId = $(this).data('index-id');

        let deactivateTeamMemberModal = new SubmitModalFlow({
            confirmModalTitle: deactivateTeamMember,
            confirmModalBody: deactivateTeamMemberDiv,
            confirmModalBtnText: deactivateBtnTxt,
            modalDialogClass: "q-modal-dialog-500",
            onConfirmClick: function() {
            
                    deactivateTeamMemberModal.showLoadingModal();
                    deactivateTeamMember({url: deactivateTeamMemberURL, success: deactivateSuccess, error: deactivateFailure});
                    function deactivateTeamMember({url, success, error}){
                         $.ajax({
                            data: {
                                userId:userId,
                                status:"false"
                              },
                            url: url,
                            dataType:"JSON",
                            type: 'POST',
                            success: success,
                            error: error
                        });
                    }
                    function deactivateSuccess(){
                        deactivateTeamMemberModal.showSuccessModal();
                        setTimeout(function() {
                            location.href=pageRefreshUrl;
                        }, 3000);
                    }
                    function deactivateFailure(){
                        deactivateTeamMemberModal.showFailureModal();
                    }
                }
        });
        deactivateTeamMemberModal.init();
        deactivateTeamMemberModal.showConfirmModal();
 });

 $('.activate-org-team-member-btn').on("click", function(e) {  
        e.preventDefault();  
        let userId = $(this).data('index-id');
        let activateTeamMemberModal = new SubmitModalFlow({
            confirmModalTitle: activateTeamMember,
            confirmModalBody: activateTeamMemberDiv,
            confirmModalBtnText: activateBtnTxt,
            modalDialogClass: "q-modal-dialog-500",
            onConfirmClick: function() {
            
                    activateTeamMemberModal.showLoadingModal();
                    activateTeamMember({url: deactivateTeamMemberURL, success: activateSuccess, error: activateFailure});
                    function activateTeamMember({url, success, error}){
                        $.ajax({
                            data:  {
                                userId:userId,
                                status:"true"
                        },
                            url: url,
                            dataType:"JSON",
                            type: 'POST',
                            success: success,
                            error: error
                        });
                    }
                    function activateSuccess(){
                        activateTeamMemberModal.showSuccessModal();
                        setTimeout(function() {
                            location.href=pageRefreshUrl;
                        }, 3000);
                    }
                    function activateFailure(){
                    activateTeamMemberModal.showFailureModal();   
                    }
                }
        });
        activateTeamMemberModal.init();
        activateTeamMemberModal.showConfirmModal();
    });
});


// WEBPACK FOOTER //
// ./src/pages/addressBook/carrierdetails.js